import {Page} from "@/libwyze-shared/types";
import React, {ReactElement, useState} from "react";
import {ButtonBase, Typography} from "@mui/material";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "@/shared/StyledComponents";
import {CheckinScreenType, CheckinState} from "./CheckinPlayerPreviewFragment";
import {CheckinLargeButton} from "@/checkin-shared/Components";
import {ArrowForwardOutlined} from "@mui/icons-material";
import {BORDER_RADIUS_MEDIUM, PD_MD, PD_SM} from "@/shared/dimens";

const VISIT_REASONS = [
  "Routine checkup",
  "I'm in pain",
  "Cleaning / scaling",
  "Cosmetic consult",
  "Braces / Invisalign",
  "Emergency",
  "Follow-up visit",
  "Something else",
];

export function VisitReasonScreen(props: {
  practicePage: Page,
  pushScreenType: (st: CheckinScreenType) => void,
  checkinState: CheckinState,
  setCheckinState: (checkin: CheckinState) => void,
}): ReactElement {
  const [selected, setSelected] = useState<string | null>(null);

  return <>
    <StyledBoxColumn style={{alignItems: "flex-start", gap: 0}}>
      <Typography variant={"h2"} style={{fontWeight: 900}}>
        What brings you in?
      </Typography>
      <Typography style={{fontSize: "100%", opacity: 0.5}}>
        Pick the one that fits best. You can tell the doctor more when you see them.
      </Typography>
    </StyledBoxColumn>
    <StyledBoxRow style={{flexWrap: "wrap", gap: PD_MD, alignSelf: "flex-start"}}>
      {VISIT_REASONS.map(reason =>
        <ButtonBase
          key={reason}
          onClick={() => setSelected(reason === selected ? null : reason)}
          style={{
            padding: `${PD_SM}px ${PD_MD}px`,
            borderRadius: BORDER_RADIUS_MEDIUM,
            border: `2px solid ${reason === selected ? "#3f51b5" : "#ccc"}`,
            backgroundColor: reason === selected ? "#e8eaf6" : "transparent",
            fontWeight: reason === selected ? 600 : 400,
            fontSize: "100%",
          }}
        >
          {reason}
        </ButtonBase>
      )}
    </StyledBoxRow>
    <StyledSpan/>
    <CheckinLargeButton
      endIcon={<ArrowForwardOutlined style={{fontSize: "125%"}}/>}
      disabled={!selected}
      style={{alignSelf: "flex-start"}}
      onClick={() => {
        props.setCheckinState({
          ...props.checkinState,
          register: {...props.checkinState.register, reason: selected},
        });
        props.pushScreenType(CheckinScreenType.CONSENT_FORM);
      }}>
      Continue
    </CheckinLargeButton>
  </>;
}
